import categoryApiFactory from '../../modules/category/categoryApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  getCategoryProductsActionCreators,
  getNextCategoryProductsActionCreators,
  getIsGameConsoleActionCreators,
  getCategoryInformationActionCreators,
  getCategoryRedirectionActionCreators,
  getKeywordsActionCreators,
  getSeoInformationCategoryActionCreators
} from '../actions/categoryActions';

function categorySagasFactory({storefrontApiClient}) {
  const productApi = categoryApiFactory(storefrontApiClient);

  const getCategoryProductsSaga = generateDefaultAsyncSaga(
    productApi.getCategoryProducts,
    getCategoryProductsActionCreators,
    payload => [
      payload.params,
      payload.cookies,
      payload.headers,
    ]
  );

  const getSeoInformationCategorySaga = generateDefaultAsyncSaga(
    productApi.getCategoryProducts,
    getSeoInformationCategoryActionCreators,
    payload => [
      payload.params,
      payload.cookies,
      payload.headers,
    ]
  );

  const getCategoryRedirectionsSaga = generateDefaultAsyncSaga(
    productApi.getCategoryRedirections,
    getCategoryRedirectionActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getNextCategoryProductsSaga = generateDefaultAsyncSaga(
    productApi.getCategoryProducts,
    getNextCategoryProductsActionCreators,
    payload => [
      payload.params,
      payload.cookies,
      payload.headers,
    ],
  );

  const getIsGameConsoleSaga = generateDefaultAsyncSaga(
    productApi.getIsGameConsole,
    getIsGameConsoleActionCreators,
    payload => [
      payload.params,
    ],
  );

  const getKeywords = generateDefaultAsyncSaga(
    productApi.getKeywords,
    getKeywordsActionCreators,
    payload => [
      payload.params,
    ],
  );

  const getCategoryInformationSaga = generateDefaultAsyncSaga(
    productApi.getCategoryInformation,
    getCategoryInformationActionCreators,
    payload => [
      payload.categoryId,
      payload.params,
    ],
  );

  const watchGetCategoryProducts = generateDefaultAsyncWatcher(
    'GET_CATEGORY_PRODUCTS',
    getCategoryProductsSaga
  );

  const watchGetSeoInformationCategory = generateDefaultAsyncWatcher(
    'GET_SEO_INFORMATION_CATEGORY',
    getSeoInformationCategorySaga
  );

  const watchGetCategoryRedirections = generateDefaultAsyncWatcher(
    'GET_CATEGORY_REDIRECTIONS',
    getCategoryRedirectionsSaga
  );

  const watchGetNextCategoryProducts = generateDefaultAsyncWatcher(
    'GET_NEXT_CATEGORY_PRODUCTS',
    getNextCategoryProductsSaga,
  );

  const watchGetIsGameConsole = generateDefaultAsyncWatcher(
    'GET_IS_GAME_CONSOLE',
    getIsGameConsoleSaga,
  );

  const watchGetCategoryInformation = generateDefaultAsyncWatcher(
    'GET_CATEGORY_INFORMATION',
    getCategoryInformationSaga,
  );

  const watchGetKeywords = generateDefaultAsyncWatcher(
    'GET_KEYWORDS',
    getKeywords,
  );

  const categorySagas = [
    watchGetCategoryProducts(),
    watchGetSeoInformationCategory(),
    watchGetNextCategoryProducts(),
    watchGetIsGameConsole(),
    watchGetCategoryInformation(),
    watchGetCategoryRedirections(),
    watchGetKeywords()
  ];

  return categorySagas;
}

export default categorySagasFactory;
